import React from 'react';
import KloudSaaSGerenteDashboard from './KloudSaaSGerenteDashboard';

export default function KloudSaaSDashboard() {
  // Por ahora todos ven la vista gerencial
  // Más adelante se pueden crear vistas específicas
  return <KloudSaaSGerenteDashboard />;
}
